import React, { ChangeEvent, FC, useCallback } from "react";
import ListBlock from "../../common/F7/ListBlock";
import { ProjectForm } from "../../../hooks/database/types/projects";

const FormSelector: FC<{
  title?: string | null;
  selectedForm: string;
  onChange: (value: any) => void;
  forms: Record<string, ProjectForm>;
}> = (props) => {
  const formOptions = Object.entries(props.forms).map(([key, form]) => {
    return { key: key, name: form.name };
  });

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLSelectElement>) => {
      const value = e.target.value;
      props.onChange(value);
    },
    [props]
  );

  return (
    <div style={{ padding: 0 }}>
      <ListBlock title={props.title || "Form"}>
        <select value={props.selectedForm} onChange={handleChange}>
          {formOptions.map((item) => (
            <option key={item.key} value={item.key}>
              {item.name}
            </option>
          ))}
        </select>
      </ListBlock>
    </div>
  );
};

export default FormSelector;
